export enum Color {
    Black,
    Green,
    Red
}

interface Answer {
    content: string;
    player1 : boolean;
    player2 : boolean;
    color : Color;
    correct : boolean | undefined,
}

export default Answer;
